import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLang } from "../i18n/LangContext";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../api/client";
import { Button } from "../components/ui/button";
import { AUTH } from "../constants/testIds";

export default function VerifyEmail() {
  const { t } = useLang();
  const { user, refresh } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState(token ? "verifying" : (user ? "pending" : "prompt"));
  const [email, setEmail] = useState(user?.email || "");
  const [resent, setResent] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (!token) return;
      try {
        await api.post("/auth/verify-email", { token });
        setStatus("success");
        if (user) await refresh();
      } catch {
        setStatus("fail");
      }
    };
    run();
  }, [token]); // eslint-disable-line

  const resend = async () => {
    try {
      await api.post("/auth/resend-verification", { email: email || user?.email });
    } catch (err) {
      console.error("resend-verification failed", err);
    }
    setResent(true);
  };

  return (
    <div className="space-y-6 text-center">
      <h1 className="font-[Outfit] text-4xl font-extrabold text-white tracking-tight">{t("auth.verifyTitle")}</h1>
      {status === "verifying" && <p data-testid={AUTH.verifyStatus} className="text-slate-400">{t("auth.verifying")}</p>}
      {status === "success" && (
        <>
          <p data-testid={AUTH.verifyStatus} className="text-emerald-300">{t("auth.verifySuccess")}</p>
          <Link to="/login" className="inline-block text-white font-semibold hover:text-[#FF3B30]">→ {t("auth.loginLink")}</Link>
        </>
      )}
      {status === "fail" && (
        <>
          <p data-testid={AUTH.verifyStatus} className="text-red-300">{t("auth.verifyFail")}</p>
          <Button data-testid={AUTH.resendVerification} onClick={resend} className="bg-[#FF3B30] hover:bg-[#E02E24] text-white font-semibold">
            {t("auth.resendVerification")}
          </Button>
          {resent && <p className="text-emerald-300 text-sm">{t("auth.resendSent")}</p>}
        </>
      )}
      {(status === "pending" || status === "prompt") && (
        <>
          <p data-testid={AUTH.verifyStatus} className="text-amber-300">{t("auth.verifyPlease")}</p>
          <div className="mx-auto max-w-xs">
            <Button data-testid={AUTH.resendVerification} onClick={resend} className="w-full bg-[#FF3B30] hover:bg-[#E02E24] text-white font-semibold">
              {t("auth.resendVerification")}
            </Button>
            {resent && <p className="mt-3 text-emerald-300 text-sm">{t("auth.resendSent")}</p>}
          </div>
          <Link to="/login" className="inline-block text-slate-400 hover:text-white text-sm">← {t("auth.loginLink")}</Link>
        </>
      )}
    </div>
  );
}
